export const CRAFTSMAN_SPECIALTIES = [
  { id: '1', label: '水電維修' },
  { id: '2', label: '電器維修' },
  { id: '3', label: '冷氣維修' },
  { id: '4', label: '一般維修' },
  { id: '5', label: '裝潢工程' },
  { id: '6', label: '清潔服務' },
  { id: '7', label: '園藝造景' },
  { id: '8', label: '監視系統' },
  { id: '9', label: '木工裝修' },
  { id: '10', label: '水塔清洗' },
] as const;

export const CRAFTSMAN_SPECIALTY_ID_TO_LABEL = CRAFTSMAN_SPECIALTIES.reduce<Record<string, string>>(
  (acc, item) => {
    acc[item.id] = item.label;
    return acc;
  },
  {}
);

export const CRAFTSMAN_SPECIALTY_LABEL_TO_ID = CRAFTSMAN_SPECIALTIES.reduce<Record<string, string>>(
  (acc, item) => {
    acc[item.label] = item.id;
    return acc;
  },
  {}
);


